import { useEffect, useState } from 'react';

// export const useScript = (url:string, callback?:Function, selector = 'body', async = true) => {
//   useEffect(() => {
//     const element = document.querySelector(selector)
//     const script = document.createElement('script')
//     script.src = url
//     script.async = async
//     if (callback) script.onload = () => callback()
//     element?.appendChild(script)
//     return () => {
//       element?.removeChild(script)
//     }
//   }, [url])

export const useCDP = () => {
    const [isCDPAvailable, setCDPAvailable] = useState(false);
    const checkCDP = () => {
        // if ('uipe' in window && typeof window?.uipe === Function) {
        if ('uipe' in window) {
            setCDPAvailable(true);
            // @ts-ignore this is a magic global parameter used by the CDP codes
            window.uipeParams = { setid: true };
            // @ts-ignore this is a magic global function created by the CDP codes
            window.uipe('init', '91266db3-502e-4d28-86ce-3a2e5c863899');
            // @ts-ignore this is a magic global parameter used by the CDP codes
            window.uipe('track', 'PageView');
        } else {
            window.setTimeout(checkCDP, 100);
        }
    };

    useEffect(() => {
        checkCDP();
    }, []);

    return isCDPAvailable;
};
